// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tip-component {
  color: var(--color-black);
  padding: 0px;
  border-radius: 0px;
}

.title {
  font-family: AppFontSemiBold, sans-serif;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  color: var(--color-black);
  margin-right: 10px;
  text-transform: uppercase;
  width: 100%;
  text-align: center;
}

.chip {
  width: -moz-fit-content;
  width: fit-content;
  padding: 5px 20px;
  text-align: start;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0em;
  text-align: left;
  text-transform: uppercase;
  border-radius: 16px;
}

.tip-img {
  height: 20px;
}

.tip {
  padding: 5px;
  margin-right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--color-white-accent);
  border-radius: 50%;
  color: #fff;
  font-family: AppFontBold, sans-serif;
  flex-direction: column;
  border: 0.5px solid #262626;
  width: 64px;
  height: 64px;
  cursor: pointer;
}
.tip:hover {
  background: var(--color-white-accent);
}
.tip .sum {
  color: var(--color-black);
  font-family: AppFontMedium, sans-serif;
  font-size: 13px;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: center;
  text-transform: uppercase;
}
.tip:last-of-type {
  margin-right: 0;
}
.tip.selected {
  background: var(--ion-color-primary);
}
.tip.selected .sum {
  color: white;
}

.custom-tip-row {
  justify-content: space-between;
}
.custom-tip-row ion-icon {
  cursor: pointer;
}

.custom {
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}

.titles-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.titles-wrapper p {
  margin-left: 15px;
}

.tip-row ion-col {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/app/components/tip/tip.component.scss"],"names":[],"mappings":"AAAA;EACC,yBAAA;EACA,YAAA;EACA,kBAAA;AACD;;AAMA;EACC,wCAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;AAHD;;AAMA;EACC,uBAAA;EAAA,kBAAA;EACA,iBAAA;EAEA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAJD;;AAOA;EACC,YAAA;AAJD;;AAOA;EACC,YAAA;EACE,iBAAA;EACF,aAAA;EAEA,uBAAA;EACA,mBAAA;EAEA,qCAAA;EACA,kBAAA;EACA,WAAA;EACA,oCAAA;EAEA,sBAAA;EACG,2BAAA;EACA,WAAA;EACA,YAAA;EACH,eAAA;AAPD;AASC;EACC,qCAAA;AAPF;AASC;EACC,yBAAA;EACA,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACG,yBAAA;AAPL;AAUC;EACC,eAAA;AARF;AAWC;EACC,oCAAA;AATF;AAUE;EACC,YAAA;AARH;;AAaA;EACC,8BAAA;AAVD;AAYC;EACC,eAAA;AAVF;;AAaA;EACC,aAAA;EACA,yBAAA;EACA,eAAA;AAVD;;AAaA;EACC,aAAA;EACA,mBAAA;EACA,2BAAA;AAVD;AAWC;EACC,iBAAA;AATF;;AAaC;EACC,aAAA;AAVF","sourcesContent":[".tip-component {\n\tcolor: var(--color-black);\n\tpadding: 0px;\n\tborder-radius: 0px;\n}\n\n.title-row {\n\n}\n\n.title {\n\tfont-family: AppFontSemiBold, sans-serif;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tletter-spacing: 0em;\n\ttext-align: left;\n\tcolor: var(--color-black);\n\tmargin-right: 10px;\n\ttext-transform: uppercase;\n\twidth: 100%;\n\ttext-align: center;\n}\n\n.chip {\n\twidth: fit-content;\n\tpadding: 5px 20px;\n\n\ttext-align: start;\n\tfont-size: 10px;\n\tline-height: 12px;\n\tletter-spacing: 0em;\n\ttext-align: left;\n\ttext-transform: uppercase;\n\tborder-radius: 16px;\n}\n\n.tip-img {\n\theight: 20px;\n}\n\n.tip {\n\tpadding: 5px ;\n  \tmargin-right: 5px;\n\tdisplay: flex;\n\n\tjustify-content: center;\n\talign-items: center;\n\n\tbackground: var(--color-white-accent);\n\tborder-radius: 50%;\n\tcolor: #fff;\n\tfont-family: AppFontBold, sans-serif;\n\n\tflex-direction: column;\n    border: 0.5px solid #262626;\n    width: 64px;\n    height: 64px;\n\tcursor: pointer;\n\n\t&:hover {\n\t\tbackground: var(--color-white-accent);\n\t}\n\t.sum {\n\t\tcolor: var(--color-black);\n\t\tfont-family: AppFontMedium,sans-serif;\n\t\tfont-size: 13px;\n\t\tline-height: 19px;\n\t\tletter-spacing: 0em;\n\t\ttext-align: center;\n    \ttext-transform: uppercase;\n\t}\n\n\t&:last-of-type {\n\t\tmargin-right: 0;\n\t}\n\n\t&.selected {\n\t\tbackground: var(--ion-color-primary);\n\t\t.sum {\n\t\t\tcolor: white;\n\t\t}\n\t}\n}\n\n.custom-tip-row {\n\tjustify-content: space-between;\n\n\tion-icon {\n\t\tcursor: pointer;\n\t}\n}\n.custom {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tcursor: pointer;\n}\n\n.titles-wrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tp {\n\t\tmargin-left: 15px;\n\t}\n}\n.tip-row {\n\tion-col {\n\t\tdisplay: flex;\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
